/***
 * token
 * @type {string}
 * @private
 */
export const __TOKEN__ = '__TOKEN__'

/***
 * 主题模式
 * @type {string}
 * @private
 */
export const __THEME_MODE__ = '__THEME_MODE__'

/***
 * 用户信息
 * @type {string}
 * @private
 */
export const __USER_INFO__ = '__USER_INFO__'

/***
 * 缓存信息
 * @type {string}
 * @private
 */
export const __CACHE_INFO__ = '__CACHE_INFO__'

/***
 * 系统配置
 * @type {string}
 * @private
 */
export const __SYSTEM_CONFIG__ = '__SYSTEM_CONFIG__'

/***
 * 字典信息
 * @type {string}
 * @private
 */
export const __DICT__ = '__DICT__'

/***
 * 系统公告
 * @type {string}
 * @private
 */
export const __SYSTEM_NOTICE__ = '__SYSTEM_NOTICE__'

/***
 * 银行列表
 * @type {string}
 * @private
 */
export const __BANK__ = '__BANK__'

/***
 * 是否隐藏余额
 * @type {string}
 * @private
 */
export const __HIDE_BALANCE__ = '__HIDE_BALANCE__'

/***
 * 静态币种[]
 * @type {string}
 * @private
 */
export const __VC_LIST__ = '__VC_LIST__'

/***
 * 自选币种列表
 * @type {string}
 * @private
 */
export const __FAVORITE_CURRENCY__ = '__FAVORITE_CURRENCY__'

/***
 * 交易配置列表
 * @type {string}
 * @private
 */
export const __TRADE_CONFIG__ = '__TRADE_CONFIG__'

/***
 * 最近查看行情的vcId
 * @type {string}
 * @private
 */
export const __VC_ID__ = '__VC_ID__'

/***
 * 首页Banner图
 * @type {string}
 * @private
 */
export const __BANNER__ = '__BANNER__'

/***
 * 语言
 * @type {string}
 * @private
 */
export const __LOCALE__ = '__LOCALE__'

/***
 * 支持的语言列表
 * @type {string}
 * @private
 */
export const __LOCALE_LIST__ = '__LOCALE_LIST__'

/***
 * 带价格的币种列表
 * @type {string}
 * @private
 */
export const __COIN_LIST_WITH_PRICE__ = '__COIN_LIST_WITH_PRICE__'



// WEBPACK FOOTER //
// ./src/utils/stroage/nameSpace.js